import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { CommonService } from 'src/app/services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';


@Component({
  selector: 'fury-block-phone-number-list',
  templateUrl: './block-phone-number-list.component.html',
  styleUrls: ['./block-phone-number-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class BlockPhoneNumberListComponent implements OnInit, OnDestroy {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input() columns = [
    { name: 'Phone Number', property: 'phoneNumber', visible: true, isModelProperty: true },
    { name: 'Action', property: 'actions', visible: true },
  ];
  itemList :any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  ngUnsubscribe = new Subject<void>();

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  constructor(
    private api: ApiService,
    private dialog: MatDialog, 
    public commonService: CommonService
    ) { }

  ngOnInit(): void {this.getBlockContact()}
  
  delete(type: string, id: string){
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type } });
    dialogref.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.api.delete(endpoints.blockContacts.blockNumbers.deleteBlockPhoneNumber(id)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((del: any) => {
          if (del.body) {
            this.api.alert(del.body?.message, ErrorType.Success);
            this.getBlockContact();
          }
        }, err => {
          if (err) {
            this.api.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  }

  getBlockContact(){
    this.api.get(endpoints.blockContacts.blockNumbers.getBlockPhoneNumbers).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (res: HttpResponse<any>) => {
        if(res.body){
          this.itemList = res.body?.blockedPhoneNumbers;
          this.dataSource = new MatTableDataSource(res.body?.blockedPhoneNumbers);
        } else {
          this.itemList = undefined;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.api.alert(err.message, ErrorType.Error);
      }
    })
  };
  onFilterChange(value: any) {
    if (!this.dataSource) {return}
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
